module.exports = __webpack_public_path__ + "img/s_3.c6f59824.png";